import { app } from '../../../app';

class ResetPasswordService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    sendResetEmail(appKey,username,resetEmail) {
        return this.$http
            .get(`app/rest/loginSAMLWeb/sendresetpwdemail/${appKey}?username=${username}&reset_pwd_email=${resetEmail}`)
            .then((response) => {
                return response.data});
    }
}

app.service('ResetPasswordService', ResetPasswordService);



// WEBPACK FOOTER //
// ./src/portal/states/public/reset-password/reset-password.service.js